import { useEffect, useState } from "react"
import { Grid, Container } from "@mui/material"
import { Route, Routes } from "react-router-dom"
import NavigationPane from "src/views/NavigationPane/NavigationPane"
import PhotoViewer from "@components/PhotoViewer/PhotoViewer"
import About from "src/views/About/About"
import MyCode from "src/views/MyCode/MyCode"
import styles from "./MainView.module.css"

const MainView = () => {
  const [photoBucket, setPhotoBucket] = useState([])
  const [showTimeoutMessage, setShowTimeoutMessage] = useState(false)

  useEffect(() => {
  const controller = new AbortController()

  fetch("/photos.json", {
    signal: controller.signal
  })
    .then((res) => res.json())
    .then((res) =>
      setPhotoBucket(
        res.map((photo) => ({
          original: `${photo.url}=w1024`,
          thumbnail: `${photo.url}=w300`,
          width: photo.width,
          height: photo.height
        }))
      )
    )
    .then(() =>
      setTimeout(() => setShowTimeoutMessage(true), 10000)
    )
    .catch((err) => {
      if (err.name === "AbortError") {
        console.log("Request cancelled")
      } else {
        console.error(err)
      }
    })

    return () => {
      controller.abort()
    }
  }, [])

  return (
    <Grid container direction={"column"} justifyContent="flex-start">
      <Grid item xs={1.5} className={styles.sticky}>
        <NavigationPane/>
      </Grid>
      <Grid item xs={10.5}>
      <Container>
        <Routes>
          <Route path="/" element={<PhotoViewer photoBucket={photoBucket} setPhotoBucket={setPhotoBucket} showTimeoutMessage={showTimeoutMessage}/>} />
          <Route path="/About" element={<About/>} />
          <Route path="/MyCode" element={<MyCode/>} />
        </Routes>
      </Container>
      </Grid>
    </Grid>
  )
}

export default MainView
